import React, { useState } from "react";
import { Check, X } from "lucide-react";

const Opt = ({ label, state, disabled, onClick, testid }) => (
  <button data-testid={testid} disabled={disabled} onClick={onClick}
    className={`text-left px-4 py-3 rounded-lg border text-sm flex items-center justify-between gap-2 transition-colors break-words ${
      state === "ok" ? "border-tc-bull/60 bg-tc-bull/10 text-tc-bull"
        : state === "bad" ? "border-tc-bear/60 bg-tc-bear/10 text-tc-bear"
        : state === "sel" ? "border-tc-coach bg-tc-coach/10" : "border-white/10 hover:border-white/30 text-tc-sub"}`}>
    {label}{state === "ok" && <Check className="w-4 h-4 shrink-0" />}{state === "bad" && <X className="w-4 h-4 shrink-0" />}
  </button>
);

// Boss item: pick the CALL, then the REASON. Only both-right passes.
export default function CallReasonStep({ step, feedback, locked, busy, onSubmit }) {
  const [call, setCall] = useState(null);
  const [reason, setReason] = useState(null);
  const [why, setWhy] = useState("");
  const ans = (locked && feedback?.correct_answer) || null;
  const st = (kind, i, sel) => {
    if (ans) return i === ans[kind] ? "ok" : sel === i ? "bad" : "";
    if (feedback && !feedback.correct && sel === i) {
      const ok = kind === "call" ? feedback.call_correct : feedback.reason_correct;
      return ok ? "ok" : "bad";
    }
    return sel === i ? "sel" : "";
  };
  return (
    <div data-testid="call-reason-step">
      <p className="text-tc-sub mt-4 font-medium">{step.prompt}</p>
      <div className="text-[10px] font-mono uppercase tracking-widest text-tc-muted mt-3">1 · Your call</div>
      <div className="grid gap-2 mt-1.5">
        {step.options.map((o, i) => <Opt key={i} testid={`call-${i}`} label={o} state={st("call", i, call)} disabled={locked || busy} onClick={() => setCall(i)} />)}
      </div>
      <div className="text-[10px] font-mono uppercase tracking-widest text-tc-muted mt-4">2 · Your reason</div>
      <div className="grid gap-2 mt-1.5">
        {step.reasons.map((o, i) => <Opt key={i} testid={`reason-${i}`} label={o} state={st("reason", i, reason)} disabled={locked || busy} onClick={() => setReason(i)} />)}
      </div>
      {step.ask_why && (
        <div className="mt-4" data-testid="call-why-box">
          <div className="text-[10px] font-mono uppercase tracking-widest text-tc-muted">3 · Why, in your own words</div>
          <textarea data-testid="call-why-input" value={why} onChange={(e) => setWhy(e.target.value)} disabled={locked || busy}
            placeholder="What made you choose this call? Saved with your call; a Call Card needs at least 10 characters."
            className="mt-1.5 w-full h-20 rounded-lg bg-tc-bg border border-white/10 px-3 py-2 text-sm outline-none focus:border-tc-coach" />
          {why.trim().length < 10 && <p className="text-[11px] text-tc-muted mt-1" data-testid="call-why-hint">Optional, but without it this run can't earn a Call Card.</p>}
        </div>
      )}
      {!locked && (
        <button data-testid="call-reason-submit" disabled={call == null || reason == null || busy}
          onClick={() => onSubmit(step.ask_why ? { call, reason, why } : { call, reason })}
          className="mt-4 w-full rounded-lg bg-tc-xp text-tc-bg font-semibold py-2.5 hover:bg-tc-xp/90 disabled:opacity-40">Lock call + reason</button>
      )}
    </div>
  );
}
